/**
 * Shell do PORTAL DO CLIENTE: topbar petróleo (wordmark + "Portal do
 * cliente" + usuário + Sair), SEM sidebar staff; conteúdo centrado max-w-5xl.
 * O router (W1) monta este layout na rota /portal com as páginas filhas.
 */
import { Outlet, useNavigate } from '@tanstack/react-router';
import { LogOut } from 'lucide-react';
import { useAuthUser } from '@/auth/use-auth';
import { performLogout } from '@/auth/logout';
import { useIsImpersonating } from '@/auth/impersonation';
import { AppBrandMark } from '@/shared/brand-mark';
import { PortalLink, portalPath } from './portal-nav';
import { NewsMegaphone } from '@/features/novidades/NewsMegaphone';
import { NewsTourHost } from '@/features/novidades/news-tour';

export function PortalLayout() {
  const user = useAuthUser();
  const navigate = useNavigate();
  // aba de depuração (spec 020): sair é "Encerrar", na faixa — daqui sairia do
  // login do admin, que não é desta aba
  const impersonating = useIsImpersonating();
  const initial = (user?.name?.trim().charAt(0) ?? '?').toUpperCase();

  const handleLogout = () => {
    // Mesmo logout do app: keycloak = end-session; local = volta pro /login.
    performLogout(() => void navigate({ to: '/login' }));
  };

  return (
    <div className="flex min-h-dvh flex-col bg-background">
      <header className="flex h-14 shrink-0 items-center justify-between bg-sidebar px-4 text-sidebar-foreground sm:px-6">
        <PortalLink
          to={portalPath.dashboard}
          aria-label="Ir para o início do portal"
          className="flex min-w-0 items-center gap-2.5"
        >
          <AppBrandMark className="text-[21px]" />
          <span aria-hidden className="hidden text-white/40 sm:inline">
            |
          </span>
          <span className="hidden truncate text-sm text-white/80 sm:inline">Portal do cliente</span>
        </PortalLink>

        <div className="flex shrink-0 items-center gap-3">
          {/* spec 036: só aparece quando houver novidade para o portal */}
          <NewsMegaphone audience="portal" tone="dark" />
          <div className="flex items-center gap-2.5">
            <div className="flex size-8 shrink-0 items-center justify-center rounded-full bg-primary text-sm font-semibold text-primary-foreground">
              {initial}
            </div>
            <span className="hidden max-w-48 truncate text-sm font-medium text-white sm:inline">
              {user?.name}
            </span>
          </div>
          {impersonating ? null : (
            <button
              type="button"
              onClick={handleLogout}
              className="flex h-8 items-center gap-1.5 rounded-md px-2.5 text-sm font-medium text-white/75 transition-colors hover:bg-white/10 hover:text-white"
            >
              <LogOut className="size-4" aria-hidden />
              Sair
            </button>
          )}
        </div>
      </header>

      <main className="mx-auto w-full max-w-5xl flex-1 px-4 py-6">
        <Outlet />
      </main>
      <NewsTourHost audience="portal" />
    </div>
  );
}
